function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import PropTypes from 'prop-types';
import { SyncLoader } from 'react-spinners';
import { Dropdown } from 'js/components/organisms/Panel/Plot/Dropdown';
import Chart from 'js/components/organisms/Chart/Scatter';
import Footer from '../../Footer';
import 'scss/cndc_prices.scss';
import RadioButtonForm from '../../../Form/Plot/Controls/Resolution';
import { PlotContainer, ClearPlotButtonContainer, SpinnerBox, Label, LegendContainer, SectionContainer, ControlsContainer, ItemContainer, Space, Panel } from './style';

var Section =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Section, _React$Component);

  function Section(props) {
    var _this;

    _classCallCheck(this, Section);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Section).call(this, props));

    _this.render = function () {
      var data = _this.props.plot.data;
      var height = _this.props.height;
      return React.createElement(SectionContainer, {
        height: height
      }, React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col-lg-12"
      }, React.createElement("h3", {
        className: "cndc-graph-section__title"
      }, _this.props.plot.metadata.title), _this.props.plot.metadata.description ? React.createElement("p", null, _this.props.plot.metadata.description) : React.createElement(Space, {
        heigth: '20px'
      }))), React.createElement("div", {
        className: "row"
      }, _this.props.panel ? React.createElement("div", {
        className: "col-sm-3 col-md-3"
      }, React.createElement(Panel, {
        height: '450px'
      }, React.createElement(LegendContainer, null, data ? React.createElement(Dropdown, {
        block: true,
        data: _this.format(data),
        countryID: _this.props.countryID,
        plotID: _this.props.plot.metadata.id,
        toggleCheckbox: _this.props.actions.toggleCheckbox,
        toggleDropdown: _this.props.actions.toggleDropdown,
        checkboxState: _this.props.plot.controls.dataShown.checkbox,
        dropdownState: _this.props.plot.controls.dataShown.dropdown
      }) : React.createElement(Space, null)), _this.props.plot.controls && _this.props.plot.controls.time_resolution && _this.props.plot.currentState && _this.props.plot.controls.time_resolution.available ? React.createElement(ControlsContainer, null, React.createElement(ItemContainer, null, React.createElement(Label, null, "Data resolution"), React.createElement(RadioButtonForm, {
        default: _this.props.plot.controls.time_resolution.default,
        handleClick: function handleClick(e) {
          return _this.handleClick(e);
        },
        data: _this.props.plot.controls.time_resolution.available,
        disabled: _this.props.plot.currentState ? _this.props.plot.currentState.loading : true
      }))) : '', React.createElement(ClearPlotButtonContainer, null))) : '', data && _this.props.plot.currentState ? React.createElement(PlotContainer, {
        className: "col-sm-8 col-md-9"
      }, React.createElement(Chart, {
        data: data,
        actions: _this.props.actions,
        plotID: _this.props.plot.metadata.id,
        currentState: _this.props.plot.currentState,
        countryID: _this.props.countryID,
        controls: _this.props.plot.controls,
        windowWidth: _this.props.windowWidth,
        loading: _this.props.plot.currentState.loading,
        checkboxState: _this.props.plot.controls.dataShown.checkbox
      })) : React.createElement(PlotContainer, {
        className: "col-sm-8 col-md-9"
      }, React.createElement(SpinnerBox, null, React.createElement(SyncLoader, {
        color: "#e9eded"
      }))), _this.props.plot.controls ? React.createElement(Footer, {
        actions: _this.props.actions,
        countryID: _this.props.countryID,
        plotID: _this.props.plot.metadata.id,
        disabled: _this.props.plot.currentState ? _this.props.plot.currentState.loading : true
      }) : React.createElement(Footer, {
        plotID: _this.props.plot.metadata.id,
        range: true
      })));
    };

    _this.state = {
      plotDataEmpty: false,
      dataFormatError: false
    };
    return _this;
  }

  return Section;
}(React.Component);

export { Section as default };
Section.propTypes = {
  id: PropTypes.string.isRequired,
  panel: PropTypes.bool,
  height: PropTypes.string.isRequired,
  countryID: PropTypes.string.isRequired,
  meta: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  plot: PropTypes.object.isRequired,
  dafault: PropTypes.string.isRequired,
  actions: PropTypes.object.isRequired,
  windowWidth: PropTypes.number.isRequired
};